import { useState } from 'react';
import InfoCircle from '../../../assets/icons/info-circle.svg?react';
import EditIcon from '../../../assets/icons/edit.svg?react';
import SystemSetUpConfirmModal from './SystemSetUpConfirmModal';

const SystemSetUpItem = ({ item, mode = 'default', disabled = false }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [value, setValue] = useState(item.Value);
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  
  const onCloseConfirmModal = () => {
    setIsConfirmModalOpen(false);
    setIsEditing(false);
    setValue(item.Value);
  }

  return (
    <>
      <div className={`system-setup-item ${isEditing ? 'edit' : ''}`}>
        <div className="system-setup-item-key flex align-center justify-center text-b2-700 text-gray-700 bg-gray-200">
          {item.Key || '-'}
          {mode === 'default' && !disabled && (
            <EditIcon className='system-setup-item-function-button cursor-pointer' color='var(--gray-600)' onClick={() => setIsEditing(true)} />
          )}
        </div>
        <div className="system-setup-item-value flex align-center px-5 text-b2-400 text-gray-600">
          {isEditing ? (
            <input type="text" className='w-full' value={value} onChange={(e) => setValue(e.target.value)} />
          ) : (
            item.Value ?? '-'
          )}
        </div>
      </div>
      {item.Description && (
        <div className="system-setup-description flex align-center gap-2">
          <InfoCircle color='var(--gray-600)' />
          <span className="text-b2-400 text-info-700">{item.Description}</span>
        </div>
      )}
      {isEditing && (
        <div className="system-setup-item-edit-function-container flex align-center gap-5">
          <p className='text-b3-400 text-primary'>값을 수정한 후 저장 버튼을 눌러주세요.</p>
          <button className='system-setup-item-edit-function-button small-btn btn btn-primary' onClick={() => {setIsConfirmModalOpen(true); } }>저장</button>
          <button className='system-setup-item-edit-function-button small-btn btn btn-style-5' onClick={() => {setIsEditing(false); setValue(item.Value); } }>취소</button>
        </div>
      )}
      {isConfirmModalOpen && (
        <SystemSetUpConfirmModal data={item} value={value} onClose={onCloseConfirmModal} mode={'edit'}/>
      )}
    </>
  )
}

export default SystemSetUpItem